import { parsePhoneNumber } from "libphonenumber-js";
import { isEmpty } from "@braid/vue-formulate/src/libs/utils";

export default function(instance) {
    instance.extend({
        validationNameStrategy: ["validationName", "label", "name", "type"],
        rules: {
            phone: ({ value }) => {
                try {
                    return parsePhoneNumber(value).isValid();
                } catch {
                    return false;
                }
            },
            nullable: ({ value }) => {
                return Promise.resolve(!isEmpty(value));
            },
            email_or_phone: ({ value }) => {
                try {
                    return (
                        // this is email validation, trust me, no need to have a big regex here
                        (value.length > 5 && value.indexOf("@") > 0) ||
                        // ... ^
                        parsePhoneNumber(value).isValid()
                    );
                } catch {
                    return false;
                }
            },
            minMaxTime: ({ value }, ...args) => {
                const min = args[0];
                const max = args[1];

                if (min !== 'null' && max !== 'null') {
                    return value >= min && value <= max;
                } else if (min !== 'null') {
                    return value >= min;
                } else if (max !== 'null') {
                    return value <= max;
                }

            }
        }
    });

}
